import Button from "@mui/material/Button";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useParams } from "react-router-dom";

import { PackageAddOnTab } from "pages/package/tabs/PackageAddOnTab";
import { PackageHistoryTab } from "pages/package/tabs/PackageHistoryTab";
import { PackageMainTab } from "pages/package/tabs/PackageMainTab";

export function PackageInfomation() {
  const [activeTab, setActiveTab] = useState(1);
  const { packageID } = useParams();

  const getButtonStyle = (tabNumber) => ({
    className: `!text-[16px] ${
      activeTab === tabNumber ? "!bg-[#2DC76D] !rounded-lg" : "!text-[#9C9C9C]"
    }`,
    variant: activeTab === tabNumber ? "contained" : "text",
    onClick: () => setActiveTab(tabNumber),
  });

  const tabContent = {
    1: <PackageMainTab />,
    2: <PackageAddOnTab />,
    3: <PackageHistoryTab />,
  };

  return (
    <>
      <nav aria-label="breadcrumb" className="mt-2 mb-4">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item">
            <Link to="/package" className="tc-7 text-decoration-none">
              แพ็คเกจ
            </Link>
          </li>
          <li className="breadcrumb-item active tc-1" aria-current="page">
            จัดการแพ็คเกจ
          </li>
        </ol>
      </nav>

      <div className="text-2xl tc-7 mb-4 lh-1">จัดการแพ็คเกจ</div>

      <div className="flex mb-4">
        <div>
          <Button {...getButtonStyle(1)}>แพ็คเกจหลัก</Button>
        </div>
        <div className="mx-4">
          <Button disabled={!packageID} {...getButtonStyle(2)}>
            แพ็คเกจเสริม
          </Button>
        </div>
        <div>
          <Button disabled={!packageID} {...getButtonStyle(3)}>
            ประวัติ
          </Button>
        </div>
      </div>

      {tabContent[activeTab]}
    </>
  );
}
